import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-error',
  templateUrl: './app-error.component.html',
  styleUrls: ['./app-error.component.scss']
})
export class AppErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
